import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BusinessCard from "@/components/BusinessCard";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowRight } from "lucide-react";
import AlertsPanel from "@/components/AlertsPanel";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/businesses").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#FDFDFC]">
      <Header />
      <section className="bg-[#1B2A4A] text-white">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14">
          <span className="text-[#E0C173] uppercase tracking-[0.25em] text-xs">Espace acheteur</span>
          <h1 className="mt-3 font-display text-3xl sm:text-4xl">Bonjour {user?.name?.split(" ")[0] || ""},</h1>
          <p className="mt-3 text-white/70 flex items-center gap-2"><CheckCircle2 className="w-5 h-5 text-[#E0C173]" /> Votre profil acheteur est actif — vous avez accès aux dossiers complets.</p>
          <Button data-testid="dashboard-catalogue-btn" onClick={() => navigate("/catalogue")} className="mt-7 rounded-full bg-[#E0C173] hover:bg-[#C9A85A] text-white px-8 py-5">
            Parcourir le catalogue <ArrowRight className="w-4 h-4 ml-2" strokeWidth={1.5} />
          </Button>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14 flex-1 w-full">
        <AlertsPanel />
        <h2 className="mt-14 font-display text-2xl text-[#1B2A4A]">Entreprises à céder</h2>
        <p className="text-sm text-[#475569] mt-1">Cliquez sur une fiche pour consulter la vidéo, les chiffres détaillés et contacter le conseiller.</p>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((b, i) => <BusinessCard key={b.business_id} b={b} index={i} />)}
        </div>
      </div>
      <Footer />
    </div>
  );
}
